import { Navigate, Outlet } from 'react-router-dom';
import { usePartnerType } from '../hooks/usePartnerType';
import { useAuth } from '../services/AuthContext';
import { useCountry } from '../context/CountryContext';

interface RoleProtectedRouteProps {
    allowedRoles: string[];
}

const RoleProtectedRoute = ({ allowedRoles }: RoleProtectedRouteProps) => {
    const { isLoading, isLoggedIn } = useAuth();
    const { role } = usePartnerType();
    const { activeCountry } = useCountry();

    if (isLoading) {
        return (
            <div className="flex h-screen w-full items-center justify-center bg-white dark:bg-[#0A0A0A]">
                <div className="flex flex-col items-center gap-4">
                    <div className="h-12 w-12 animate-spin rounded-full border-[3px] border-slate-200 dark:border-white/10 border-t-slate-900 dark:border-t-white"></div>
                    <span className="text-[10px] font-bold tracking-[0.3em] text-slate-400 animate-pulse">Verifying Access</span>
                </div>
            </div>
        );
    }

    if (!isLoggedIn) {
        return <Navigate to="/" replace />;
    }

    if (!allowedRoles.includes(role)) {
        // Redirect unauthorized users to their dashboard
        const prefix = activeCountry ? `/${activeCountry.code.toLowerCase()}` : '';
        return <Navigate to={`${prefix}/partners/dashboard`} replace />;
    }

    return <Outlet />;
};

export default RoleProtectedRoute;
